export default __webpack_public_path__ + "static/media/Logo Gualtieri.54cadcd8.svg";